import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef
} from '@angular/core';
import * as JSONEditor from 'jsoneditor';

@Component({
    selector: 'json-edit',
    templateUrl: './edit-json.component.html',
    standalone: false
})
export class EditJsonComponent implements OnInit {
  @Input() public object: any;
  @Output() public toggleSave: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  @Input() public processing: boolean;
  @Input() public type: string;
  @ViewChild('jsoneditor', { read: ElementRef, static: true }) jsoneditor: ElementRef;
  editor: any;

  constructor(private cdf: ChangeDetectorRef) {}

  ngOnInit(): void {
    const options = { mode: 'code', modes: ['tree', 'code', 'text'] };
    this.editor = new JSONEditor(this.jsoneditor.nativeElement, options);
    this.editor.set(this.object);
  }

  public update() {
    this.toggleSave.emit(this.editor.get());
  }

  public cancel() {
    this.toggleCancel.emit();
  }
}
